const extractBookAppointmentError = (failures) => {
  if (failures && failures.length > 0 && failures[0]?.__typename) {
    return failures[0].__typename;
  }
};
export {
  extractBookAppointmentError
};
//# sourceMappingURL=extract-book-appointment-error.js.map
